<template>
    <div>
        <div v-if="token_exists">
            <paya-report-table></paya-report-table>
        </div>
        <div v-else>
            {{ $t('label.token_does_not_exist') }}
        </div>
    </div>
</template>

<script>
    import {walletService} from "@/common/api.service";
    import PayaReportTable from "./paya-report-table";
    import {walletReportType} from "@/constants/WalletReportType";

    export default {
        components: {
            PayaReportTable,
        },
        data() {
            return {
                walletReportType,
                token_exists: false,
            };
        },
        mounted() {
            let params = {
                wallet_prefix: 'A',
                type: walletReportType.PAYA,
            };

            walletService.getReportAccess(params).then(res => {
                this.token_exists = res.data.data.token_exists;

                if (! this.token_exists) {
                    window.location = res.data.data.url;
                }
            });
        },
    }
</script>
